import { ensureRouteData, prefetchRouteData } from '@/app/query-client'
import {
  planQueryOptions,
  plansQueryOptions,
  subscriptionMeQueryOptions,
} from '@/features/subscriptions/api/queries'
import { buildCatalog } from '@/features/subscriptions/lib/catalog'
import type { RouterContext } from '@/routes/layouts/root'
import { featurePlanIds } from '@/screens/account/components/plans/planGrid'

/**
 * The `/subscription` loader.
 *
 * MAIN, both awaited: the catalogue (every price on the cards) and the
 * member's entitlement (the banner, and which card says "Your plan" — drawn
 * without it, a Guru member's card would read "Choose Guru" and then flip).
 *
 * SECONDARY, after them and only on a real navigation: each card's feature
 * flags. A card draws its own skeleton and its own failure for those, so one
 * slow `plans/{id}` never holds the prices back. Every period's plans are
 * asked for at once, so switching the period is instant.
 */
export async function loadSubscription({
  context: { queryClient },
  preload,
}: {
  context: RouterContext
  preload: boolean
}): Promise<void> {
  const [plans, me] = await Promise.all([
    ensureRouteData(queryClient, plansQueryOptions()),
    ensureRouteData(queryClient, subscriptionMeQueryOptions()),
  ])
  if (preload) return
  for (const planId of featurePlanIds(buildCatalog(plans), me)) {
    prefetchRouteData(queryClient, planQueryOptions(planId))
  }
}
